import Layout from "../../components/mainPage/Layout";
import manufactureImg from "../../images/manufacture.png"
import { Add } from "shared/components/Add";
import image from "../../images/SCADAHPS.png";
import { ImageContainer } from "shared/components/ImageContainer";
export const Page = () => {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="mb-4 ">
            Генерация
          </h1>


          <h1 className="article-title">
            SCADA NPT Expert для автоматизации электростанций: интеллектуальное
            управление энергогенерацией
          </h1>
          <p className="article-lead">
            Современные электростанции (тепловые, атомные, гидроэлектростанции)
            требуют высокоэффективного управления для обеспечения бесперебойной
            работы, безопасности и максимальной производительности.
            SCADA-система (Supervisory Control And Data Acquisition) — это
            мощный инструмент для автоматизации технологических процессов,
            мониторинга оборудования и оптимизации энергогенерации.
          </p>



          <h2 className="section-title">
            Ключевые возможности SCADA NPT Expert для электростанций:
          </h2>
          <ul className="benefits-list">
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Централизованное управление</strong> – контроль всех
              ключевых параметров (давление, температура, мощность, частота) в
              едином интерфейсе.
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Автоматизация процессов</strong> – минимизация ручного
              вмешательства, автоматический пуск/останов агрегатов, регулировка
              нагрузки и т.д.
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Мониторинг в реальном времени</strong> – визуализация
              состояния оборудования, прогнозирование отказов, предотвращение
              аварий.
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Анализ данных и отчетность</strong> – сбор статистики,
              формирование отчетов для повышения энергоэффективности.
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>
                Простая интеграция со смежными системами и системами
                безопасности
              </strong>{" "}
              – совместимость с системами технологических защит, диспетчеризации
              и Smart Grid.
            </li>
          </ul>

          <h2 className="section-title">
            Варианты применения на разных типах электростанций:
          </h2>
          <div className="variants-list">
            <div className="quote-box">
              <strong>🔹 ТЭС</strong> – контроль котлов, турбин, топливных
              систем, оптимизация КПД.
            </div>
            <div className="quote-box">
              <strong>🔹 АЭС</strong> – мониторинг реакторов, систем охлаждения,
              радиационной безопасности.
            </div>
            <div className="quote-box">
              <strong>🔹 ГЭС</strong> – управление гидроагрегатами, уровнем
              воды, защита от перегрузок.
            </div>
          </div>


          <ImageContainer
            src={image}
            alt={'SCADA NPT Expert в работе на современной ГЭС'}
            caption={'SCADA NPT Expert в работе на современной ГЭС'}
          />
          <Add
            text={<><span className="text-accent">Автоматизируйте</span> управление Вашей электростанцией с передовыми SCADA NPT решениями!</>}
            description={'Переход на Industry 4.0 начинается с выбора правильной системы автоматизации.'}
            image={manufactureImg}
          />
        </div>
      </div>
    </Layout>
  );
};

export const meta = {
  title: 'Генерация',
  description: 'SCADA NPT Expert для автоматизации электростанций: интеллектуальное управление энергогенерацией'
}
